import { render, staticRenderFns } from "./Product1.vue?vue&type=template&id=19df9d2c&scoped=true"
import script from "./Product1.vue?vue&type=script&lang=js"
export * from "./Product1.vue?vue&type=script&lang=js"
import style0 from "./Product1.vue?vue&type=style&index=0&id=19df9d2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19df9d2c",
  null
  
)

export default component.exports